<div class="flex flex-col flex-auto min-w-0 h-full bg-gray-50 dark:bg-gray-900" *ngIf="!showList; else showDestination">

    <div class="sticky top-0 z-10 bg-white dark:bg-gray-800 shadow-sm border-b dark:border-gray-700">
        <div class="mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">

                <div *ngIf="userUiType === 4">
                    <h1 class="text-2xl font-bold tracking-tight text-gray-900 dark:text-white truncate">
                        {{ title }} Affiliates
                    </h1>
                    <p class="text-sm text-gray-500 dark:text-gray-400">View and manage affiliates business registered
                        under your campaign</p>
                </div>

                <div *ngIf="userUiType === 2">
                    <h1 class="text-2xl font-bold tracking-tight text-gray-900 dark:text-white truncate">
                        {{ title }}
                    </h1>
                    <p class="text-sm text-gray-500 dark:text-gray-400">Manage your business properties and offerings</p>
                </div>

                <div *ngIf="userUiType === 3">
                    <h1 class="text-2xl font-bold tracking-tight text-gray-900 dark:text-white truncate">
                        {{ title }}
                    </h1>
                    <p class="text-sm text-gray-500 dark:text-gray-400">Manage and organize your content locations</p>
                </div>

                <div class="flex flex-wrap items-center gap-3 self-start md:self-auto">

                    <mat-checkbox *ngIf="userUiType === 4" [formControl]="deletedControl" color="warn" class="hidden md:inline-flex mr-4">
                        Incomplete Business Registration
                    </mat-checkbox>

                    <button mat-stroked-button (click)="showFilters = !showFilters"
                            [color]="showFilters ? 'primary' : ''">
                        <mat-icon [svgIcon]="'heroicons_outline:adjustments-horizontal'"></mat-icon>
                        <span class="ml-2">Filters</span>
                    </button>

                    <button mat-flat-button color="primary"
                            *ngIf="!displayAddDestination && !reviewMode && (userUiType === 3 || userUiType === 2)"
                            (click)="displayAddDestination = true">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        <span class="ml-2">New</span>
                    </button>

                    <a mat-flat-button color="primary"
                       *ngIf="userUiType === 4"
                       [href]="'https://kixaconnect.com/register?am_id=' + amCampaignId">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        <span class="ml-2">New</span>
                    </a>
                </div>
            </div>

            <div class="mt-4 border-t pt-4 dark:border-gray-700" *ngIf="showFilters" @fadeIn>
                <form [formGroup]="searchForm" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic" *ngIf="userUiType !== 4">
                        <mat-label>Name</mat-label>
                        <mat-icon matPrefix [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                        <input matInput formControlName="name" placeholder="Search by name">
                    </mat-form-field>

                    <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic" *ngIf="userUiType !== 4">
                        <mat-label>Parent</mat-label>
                        <input matInput formControlName="parent" placeholder="Filter by parent">
                    </mat-form-field>

                    <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
                        <mat-label *ngIf="userUiType === 4">Search</mat-label>
                        <mat-label *ngIf="userUiType !== 4">Keyword</mat-label>
                        <input matInput formControlName="keyword" placeholder="Filter by keyword">
                    </mat-form-field>

                    <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic"
                                    *ngIf="!reviewMode && userUiType !== 4">
                        <mat-label>State</mat-label>
                        <mat-select formControlName="type">
                            <mat-option *ngFor="let item of searchParameters" [value]="item.value">
                                {{ item.view }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="flex items-center sm:col-span-2 lg:col-span-1" *ngIf="userUiType !== 4">
                        <mat-checkbox formControlName="deleted" color="warn">Show Deleted</mat-checkbox>
                    </div>

                    <div class="flex items-center sm:col-span-2 lg:col-span-1 md:hidden" *ngIf="userUiType === 4">
                        <mat-checkbox formControlName="deleted" color="warn">Incomplete Business Registration</mat-checkbox>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="flex-auto overflow-y-auto p-4 sm:p-6 lg:p-8">

        <ng-container *ngIf="!displayAddDestination">
            <ng-container *ngIf="tableElements?.length > 0; else noProducts">
                <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">

                    <div *ngFor="let element of tableElements"
                         class="group relative flex flex-col bg-white dark:bg-card rounded-2xl shadow hover:shadow-lg transition-shadow duration-300 overflow-hidden border border-gray-100 dark:border-transparent">

                        <div class="h-1.5 w-full" [ngClass]="getStateIndicatorColor(element.ds_en_state)"></div>

                        <div class="p-5 flex flex-col flex-auto">
                            <div class="flex flex-wrap items-center justify-between mb-3 gap-2">
                                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200 border border-gray-200 dark:border-transparent">
                                    {{ element.ds_en_destinationtype === 'Undefined Value' ? 'Uncategorized Business' : (element.ds_en_destinationtype || 'Unknown Type') }}
                                </span>
                                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold"
                                      [ngClass]="getStateBadgeClass(element.ds_en_state)">
                                    {{ element.ds_en_state }}
                                </span>
                            </div>

                            <h3 class="text-lg font-bold text-gray-900 dark:text-gray-100 mb-1 leading-tight group-hover:text-primary transition-colors">
                                {{ element.ds_name || 'Unnamed Destination' }}
                            </h3>
                            <p class="text-xs text-gray-400 font-mono mb-4">ID: {{ element.id_destination }}</p>

                            <div class="text-sm text-gray-600 dark:text-gray-400 line-clamp-3 mb-4 flex-auto">
                                {{ removeHtmlTags(element.tx_description) || 'No description available for this destination.' }}
                            </div>

                            <div class="mt-auto border-t pt-4 flex items-center justify-between">
                                <button mat-button color="primary"
                                        (click)="switchToDestination(element.id_destination)">
                                    <span class="flex items-center">
                                        Manage
                                        <mat-icon iconPositionEnd [svgIcon]="'heroicons_outline:arrow-long-right'" class="ml-1 icon-size-4"></mat-icon>
                                    </span>
                                </button>

                                <button mat-icon-button color="accent" matTooltip="Generate QR Codes" (click)="openQrDialog(element, qrDialogTemplate)">
                                    <mat-icon [svgIcon]="'heroicons_outline:qr-code'"></mat-icon>
                                </button>
                            </div>
                        </div>

                        <mat-expansion-panel class="shadow-none rounded-none border-t bg-gray-50 dark:bg-gray-800" *ngIf="userUiType !== 4">
                            <mat-expansion-panel-header class="h-10 px-4">
                                <mat-panel-title class="text-xs text-gray-500">Original Data</mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="p-2 overflow-x-auto">
                                <pre class="text-xs text-gray-600 dark:text-gray-400 font-mono whitespace-pre-wrap">{{ element | json }}</pre>
                            </div>
                        </mat-expansion-panel>
                    </div>

                </div>
            </ng-container>

            <ng-template #noProducts>
                <div class="flex flex-col items-center justify-center p-12 text-center opacity-75">
                    <div class="bg-gray-100 p-4 rounded-full dark:bg-gray-800 mb-4">
                        <mat-icon class="icon-size-12 text-gray-400"
                                  [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                    </div>
                    <div class="text-xl font-semibold text-gray-800 dark:text-gray-200">{{ loadingMessage }}</div>
                    <p class="text-gray-500 mt-2">Try adjusting your filters or search terms.</p>
                    <ngx-spinner bdColor="rgba(0,0,0,0)" color="#6366f1" size="medium" type="ball-clip-rotate"></ngx-spinner>
                </div>
            </ng-template>
        </ng-container>

        <div *ngIf="displayAddDestination" class="w-full max-w-3xl mx-auto" @fadeIn>
            <div class="bg-white dark:bg-card p-6 md:p-8 rounded-2xl shadow-xl ring-1 ring-black/5">

                <div class="mb-8">
                    <h2 class="text-2xl font-bold">Add Destination</h2>
                    <p class="text-gray-500">Creating new item for <span class="font-semibold text-primary">{{ destinationType?.ds_name }}</span></p>
                </div>

                <form [formGroup]="newDestinationForm" (ngSubmit)="createDestination($event)">
                    <fuse-alert class="mb-6" *ngIf="alert" [type]="alert.type" [showIcon]="false">
                        {{ alert.message }}
                    </fuse-alert>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                        <div class="col-span-1 md:col-span-2">
                            <mat-form-field class="w-full">
                                <mat-label>Destination Type</mat-label>
                                <input matInput [value]="destinationType?.ds_label || ''" readonly>
                                <mat-icon matSuffix [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
                            </mat-form-field>
                        </div>

                        <div class="col-span-1 md:col-span-2">
                            <mat-form-field class="w-full">
                                <mat-label>Descriptive Name</mat-label>
                                <input matInput formControlName="ds_name" required maxlength="150" placeholder="e.g. Summer Campaign 2024">
                                <mat-error *ngIf="newDestinationForm.get('ds_name').hasError('required')">Name is required</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-span-1 md:col-span-2">
                            <mat-form-field class="w-full">
                                <mat-label>Parent Destination</mat-label>
                                <input type="text"
                                       placeholder="Start typing to search..."
                                       matInput
                                       [formControl]="parentControl"
                                       [matAutocomplete]="auto"
                                       (blur)="onBlur()">
                                <mat-autocomplete #auto="matAutocomplete"
                                                  [displayWith]="displayFn"
                                                  (optionSelected)="selectClick($event)">
                                    <mat-option *ngFor="let parent of destinationParentsArrayObserve | async"
                                                [value]="parent">
                                        <div class="flex flex-col py-1">
                                            <span class="font-medium">{{ parent.ds_name }}</span>
                                            <span class="text-xs text-gray-500">ID: {{ parent.id_destination }}</span>
                                        </div>
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="parentControl.invalid">Select a valid parent or leave empty</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-100 dark:border-gray-700">
                        <button type="button" mat-button (click)="displayAddDestination = false">Cancel</button>
                        <button type="submit" mat-flat-button color="primary" [disabled]="newDestinationForm.invalid">
                            Create Record
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="bg-white dark:bg-card border-t dark:border-gray-700 p-2">
        <mat-paginator
            [disabled]="showList"
            (page)="searchElements('paginator')"
            [length]="20"
            [pageSize]="20"
            [pageSizeOptions]="[10, 20, 50, 100]"
            [showFirstLastButtons]="true"
            class="bg-transparent">
        </mat-paginator>
    </div>
</div>

<ng-template #showDestination>
    <destinations-management
        (commandEvent)="handleCommand($event)"
        class="w-full h-full block overflow-hidden"
        [reviewMode]="reviewMode"
        [destinationTypesArray]="destinationTypesArray"
        [destination_ID]="destination_ID"
        [adminMode]="true">
    </destinations-management>
</ng-template>

<ng-template #qrDialogTemplate>
    <div class="flex flex-col h-full max-h-[90vh] overflow-hidden bg-gray-50">

        <div class="flex items-center justify-between p-4 bg-white border-b shadow-sm shrink-0">
            <div class="flex flex-col">
                <h2 class="text-xl font-bold flex items-center gap-2 m-0">
                    <mat-icon>qr_code_2</mat-icon>
                    <span>QR Generator</span>
                </h2>
                <span class="text-sm font-normal text-gray-500 mt-0.5" *ngIf="selectedQrBusiness">
                    for {{selectedQrBusiness.ds_name}}
                </span>
            </div>

            <div class="flex items-center gap-2 ml-2">
                <button mat-icon-button [mat-dialog-close]="true">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <mat-progress-bar *ngIf="isGeneratingQr" mode="indeterminate" class="w-full"></mat-progress-bar>

        <div class="flex-auto overflow-y-auto p-4 md:p-6" *ngIf="generatedLinks">

            <div class="max-w-4xl mx-auto bg-white rounded-xl shadow-sm border p-4 md:p-6">
                <mat-tab-group class="w-full" animationDuration="300ms">

                    <mat-tab label="Mobile App">
                        <div class="flex flex-col md:flex-row items-center justify-center gap-8 p-6">
                            <div class="bg-white p-2 border rounded-xl shadow-sm shrink-0">
                                <ngx-qrcode-styling [config]="mobileQrConfig"></ngx-qrcode-styling>
                            </div>
                            <div class="flex flex-col gap-4 w-full md:max-w-md text-center md:text-left">
                                <div>
                                    <h3 class="text-xl font-bold" [style.color]="selectedSkin?.themeColor">Mobile App DeepLink</h3>
                                    <p class="text-sm text-gray-600 mt-1">Scan to download the app configured for {{ selectedSkin?.name }}.</p>
                                </div>

                                <button mat-flat-button [style.background-color]="selectedSkin?.themeColor" class="text-white w-full md:w-auto h-12" (click)="downloadQr('mobile')">
                                    <mat-icon class="mr-2">download</mat-icon> Download PNG
                                </button>

                                <div class="p-3 bg-gray-50 rounded border text-xs break-all cursor-pointer hover:bg-gray-100 transition-colors"
                                     (click)="copyUrl(generatedLinks?.mobileUrl)" matTooltip="Click to Copy URL">
                                    {{ generatedLinks?.mobileUrl }}
                                </div>
                            </div>
                        </div>
                    </mat-tab>

                    <mat-tab label="Desktop Web">
                        <div class="flex flex-col md:flex-row items-center justify-center gap-8 p-6">
                            <div class="bg-white p-2 border rounded-xl shadow-sm shrink-0">
                                <ngx-qrcode-styling [config]="desktopQrConfig"></ngx-qrcode-styling>
                            </div>
                            <div class="flex flex-col gap-4 w-full md:max-w-md text-center md:text-left">
                                <div>
                                    <h3 class="text-xl font-bold" [style.color]="selectedSkin?.themeColor">Web Sign-Up Link</h3>
                                    <p class="text-sm text-gray-600 mt-1">Scan to go to the {{ selectedSkin?.name }} registration page.</p>
                                </div>

                                <button mat-flat-button [style.background-color]="selectedSkin?.themeColor" class="text-white w-full md:w-auto h-12" (click)="downloadQr('desktop')">
                                    <mat-icon class="mr-2">download</mat-icon> Download PNG
                                </button>

                                <div class="p-3 bg-gray-50 rounded border text-xs break-all cursor-pointer hover:bg-gray-100 transition-colors"
                                     (click)="copyUrl(generatedLinks?.desktopUrl)" matTooltip="Click to Copy URL">
                                    {{ generatedLinks?.desktopUrl }}
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>

                <div class="hidden-offscreen">
                    <ngx-qrcode-styling [config]="bigMobileQrConfig"></ngx-qrcode-styling>
                    <ngx-qrcode-styling [config]="bigDesktopQrConfig"></ngx-qrcode-styling>
                </div>
            </div>
        </div>
    </div>
</ng-template>
